import { call, put, select } from "redux-saga/effects";
import { TempIdsMap, updateTempIdMap } from "../../../../api/api-slice";
import ComponentsService from "../../../../../services/ComponentsService";
import {
  selectComponentTempIdsMap,
  selectWeekTempIdsMap,
} from "../../../../api/selectors";
import { CreatedComponentResult } from "@growth-machine-llc/stridist-api-client";
import { setComponentSlug } from "../../../curriculum-slice";
import { updateToastAlert } from "../../../../../utils/toast";

export default function* splitRepeatWorker(payload: {
  weekId: number;
  componentId: number;
  newComponentId: number;
  toastId: string | number;
}) {
  const { weekId, componentId, newComponentId: tempId } = payload;
  const weekMap: TempIdsMap = yield select(selectWeekTempIdsMap);
  const componentMap: TempIdsMap = yield select(selectComponentTempIdsMap);
  const checkedWeekId = weekMap?.[weekId] || weekId;
  const checkedComponentId = componentMap?.[componentId] || componentId;
  try {
    const res: CreatedComponentResult = yield call(
      ComponentsService.splitRepeat,
      checkedComponentId,
      checkedWeekId,
    );
    const realId = res.id;
    yield put(setComponentSlug([{ id: tempId, slug: res.slug }]));
    yield put(
      updateTempIdMap({
        type: "components",
        tempId: tempId.toString(),
        realId,
      }),
    );
    // Send update on both containers to guarantee targeting the right one
    updateToastAlert(payload.toastId, {
      message: "Done!",
      severity: "success",
      containerId: "desktop-toast-alert-container",
    });
    updateToastAlert(payload.toastId, {
      message: "Done!",
      severity: "success",
      containerId: "mobile-toast-alert-container",
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
}
